import { mdiClose } from '@mdi/js'
import { useTranslation } from 'react-i18next'
import { AppIcon } from './ui/icon'
import { Button } from './ui/button'
import { cn } from '../lib/utils'
import type { SessionEndedReason } from '../contexts/refresh-session'

interface AuthErrorBannerProps {
  onDismiss: () => void
  loginUrl: string
  /** Why the server ended the session, when it said so. */
  reason?: SessionEndedReason | null
  className?: string
}

export function AuthErrorBanner({ onDismiss, loginUrl, reason, className }: AuthErrorBannerProps) {
  const { t } = useTranslation('auth')
  return (
    <div className={cn(
      "w-full bg-destructive text-white px-4 py-3 flex items-center justify-between",
      className
    )} data-testid="auth-error-banner" data-reason={reason ?? undefined}>
      <div className="flex items-center gap-3">
        <div className="text-sm font-medium">
          {t(reason ? `sessionEnded.${reason}` : 'sessionEnded.expired')}
        </div>
        <a
          href={loginUrl}
          className="text-sm font-medium underline hover:no-underline"
          data-testid="auth-error-banner-login"
        >
          {t('sessionEnded.logIn')}
        </a>
      </div>
      <Button
        variant="ghost"
        size="icon"
        onClick={onDismiss}
        className="h-6 w-6 text-white hover:bg-white/20"
        aria-label={t('sessionEnded.dismiss')}
        title={t('sessionEnded.dismiss')}
        data-testid="auth-error-banner-dismiss"
      >
        <AppIcon path={mdiClose} size="sm" />
      </Button>
    </div>
  )
}
